// extracted by mini-css-extract-plugin
module.exports = {"uploadButton":"index_uploadButton__38s8q","uploadButton_tip":"index_uploadButton_tip__3Xh04","tip":"index_tip__1SrCJ","videoTip":"index_videoTip__3iRx5"};